import { render } from "./ModalPipe.vue?vue&type=template&id=53b384dc&scoped=true"
import script from "./ModalPipe.vue?vue&type=script&lang=js"
export * from "./ModalPipe.vue?vue&type=script&lang=js"

import "./ModalPipe.vue?vue&type=style&index=0&id=53b384dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b384dc"]])

export default __exports__